import { styled } from '@mui/material/styles';

export const Section = styled('section', { name: 'Section' })(({ theme }) => ({
  paddingBottom: theme.spacing(4),
}));
